import React, { useEffect, useState } from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "./progressbarTimer.css";

const ProgressbarTimer = ({ userFullAttendenceData }) => {
  const [percentage, setPercentage] = useState(0);
  const [formattedTime, setFormattedTime] = useState("0h 0m");
  const [isCheckedOut, setIsCheckedOut] = useState(false);

  const calculateTimeDifference = (checkInTime, checkOutTime) => {
    const start = new Date(checkInTime);
    const end = checkOutTime ? new Date(checkOutTime) : new Date();
    const diffMs = end - start;

    const hours = Math.floor(diffMs / (1000 * 60 * 60));
    const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

    return { hours, minutes, totalHours: hours + minutes / 60 };
  };

  const updateWorkingTime = () => {
    const checkoutTime =
      userFullAttendenceData?.todayAttendance?.checkOutApproval ===
      "Approved Edited"
        ? userFullAttendenceData?.todayAttendance
            ?.manager_approve_check_out_time
        : userFullAttendenceData?.todayAttendance?.check_out_time ||
          userFullAttendenceData?.todayAttendance?.manager_check_out_time ||
          userFullAttendenceData?.todayAttendance?.auto_approve_check_out_time;

    const checkInTime =
      userFullAttendenceData?.todayAttendance?.checkInApproval ===
      "Approved Edited"
        ? userFullAttendenceData?.todayAttendance?.manager_approve_check_in_time
        : userFullAttendenceData?.todayAttendance?.check_in_time
        ? userFullAttendenceData?.todayAttendance?.check_in_time
        : userFullAttendenceData?.todayAttendance?.manager_check_in_time
        ? userFullAttendenceData?.todayAttendance?.manager_check_in_time
        : userFullAttendenceData?.todayAttendance?.auto_approve_check_in_time;

    let hours = 0;
    let minutes = 0;
    let workingHours = 0;
    let calculatedPercentage = 0;

    console.log("Check-in:", checkInTime, "Checkout:", checkoutTime);

    if (checkInTime) {
      if (checkoutTime) {
        // Static working hours after checkout
        setIsCheckedOut(true);
        const {
          hours: h,
          minutes: m,
          totalHours,
        } = calculateTimeDifference(checkInTime, checkoutTime);
        hours = h;
        minutes = m;
        workingHours = totalHours;
      } else {
        // Real-time calculation before checkout
        setIsCheckedOut(false);
        const {
          hours: h,
          minutes: m,
          totalHours,
        } = calculateTimeDifference(checkInTime);
        hours = h;
        minutes = m;
        workingHours = totalHours;
      }

      const totalWorkingHours =
        parseFloat(
          userFullAttendenceData?.todayAttendance?.dailyTotalWorkingHours
        ) || 8;

      if (totalWorkingHours > 0) {
        calculatedPercentage = Math.min(
          (workingHours / totalWorkingHours) * 100,
          100
        );
      }

      calculatedPercentage = isNaN(calculatedPercentage)
        ? 0
        : Math.round(calculatedPercentage);
    }

    const formattedTime = `${hours}h ${minutes}m`;
    console.log(
      "Formatted Time:",
      formattedTime,
      "Percentage:",
      calculatedPercentage
    );

    setFormattedTime(formattedTime);
    setPercentage(calculatedPercentage);
  };

  useEffect(() => {
    updateWorkingTime();
    const interval = setInterval(updateWorkingTime, 30000); // Update every 30 seconds
    return () => clearInterval(interval);
  }, [userFullAttendenceData]);

  return (
    <div className="progress-container">
      <div className="progress-bor">
        <div className="progress-circular">
          <CircularProgressbar
            value={percentage}
            text=""
            styles={buildStyles({
              pathColor: "#000080",
              trailColor: "transparent",
            })}
          />
        </div>
      </div>
      <div className="progress-text">{formattedTime}</div>
    </div>
  );
};

export default ProgressbarTimer;
